// assets
import {
  LoginOutlined,
  ProfileOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { FormattedMessage, useIntl } from "react-intl";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DescriptionIcon from "@mui/icons-material/Description";
import GroupIcon from "@mui/icons-material/Group";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import SearchOutlined from "@mui/icons-material/SearchOutlined";
// icons

const useResumeItems = () => {
  const icons = {
    LoginOutlined,
    ProfileOutlined,
    FileTextOutlined,
    BusinessCenterOutlinedIcon,
    SettingsOutlinedIcon,
    CheckCircleOutlineIcon,
    DescriptionIcon,
    GroupIcon,
    ToggleOnIcon,
    ToggleOffIcon,
    SearchOutlined,
  };

  // ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

  const resume = {
    id: "Resume Management",
    title: (
      <FormattedMessage id="Individuals">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    icon: icons.DescriptionIcon,
    type: "group",
    // url: "/list-jobseekers",

    children: [
      {
        id: "jobseekers",
        title: <FormattedMessage id="Individuals" />,
        type: "item",
        url: "/jobseekers",
        icon: icons.GroupIcon,
        breadcrumbs: false,
      },
      {
        id: "resumes",
        title: <FormattedMessage id="Resumes List" />,
        type: "item",
        url: "/resumes",
        icon: icons.FileTextOutlined,
        breadcrumbs: false,
      },
      {
        id: "active-resume",
        title: <FormattedMessage id="Active Resumes" />,
        type: "item",
        url: "/resumes?status=Active",
        icon: icons.ToggleOnIcon,
        breadcrumbs: false,
      },
      {
        id: "unactive-resume",
        title: <FormattedMessage id="Unactive Resumes" />,
        type: "item",
        url: "/resumes?status=Unactive",
        icon: icons.ToggleOffIcon,
        breadcrumbs: false,
      },
      {
        id: "search-resumes",
        title: <FormattedMessage id="Search Resumes" />,
        type: "item",
        url: "/search-resumes",
        icon: icons.SearchOutlined,
      },
      // {
      //   id: "resume-management-report",
      //   title: <FormattedMessage id="Resume Report" />,
      //   type: "item",
      //   url: "/resume-management-report",
      //   icon: icons.ProfileOutlined,
      //   breadcrumbs: false,
      // },

      // {
      //   id: "list-of-send-resumes",
      //   title: <FormattedMessage id="Send Resumes" />,
      //   type: "item",
      //   url: "/list-of-send-resumes",
      //   icon: icons.FileTextOutlined,
      //   breadcrumbs: false,
      // },
      // {
      //   id: "status",
      //   title: <FormattedMessage id="Account Status" />,
      //   type: "item",
      //   url: "/account-status",
      //   icon: icons.SettingsOutlinedIcon,
      //   breadcrumbs: false,
      // },
    ],
  };
  return resume;
};

export default useResumeItems;
